import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sellions-layout-renderer-table-removal-confirmation-dialog',
  templateUrl: './removal-confirmation-dialog.component.html',
})
export class RemovalConfirmationDialog {
  constructor(private dialogRef: MatDialogRef<RemovalConfirmationDialog>) {}

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/removal-confirmation-dialog/removal-confirmation-dialog.component.ts